import type { ModelFilterValue } from 'src/components/GenerationModel/ModelFilter.helper'
import type { OrderOptionType } from 'src/services/helpers/orderOptionParams'
import { OrderOption } from 'src/services/helpers/orderOptionParams'
import { createCtx } from 'src/utils/contextState'

export const [ModelFormContext, ModelFormContextProvider] =
  createCtx<ModelFormContextStateType>({
    type: null,
    versionId: null,
    modelId: null,
    searchKeyword: '',
    openDetail: false,
    marketOrder: OrderOption.trending,
    bookmarkListOrder: OrderOption.newest,
    tab: 'preset',
    marketFilters: {
      type: 'model',
    },
  })

export type ModelTabType = 'preset' | 'bookmark' | 'market'

export type ModelFormContextStateType = {
  type: ModelTabType | null
  versionId: string | null
  modelId: string | null

  /**
   * For debounced search
   */
  searchKeyword: string

  /**
   * Whether the current model is selected by clicking,
   * therefore should pop up detail dialog.
   */
  openDetail: boolean

  marketOrder?: OrderOptionType
  marketFilters?: ModelFilterValue
  bookmarkListOrder?: OrderOptionType
  tab: ModelTabType
}
